import React from 'react';
import { CarouselData } from '../../shared/dto/EntityRepository';
import { DisplaySize, PEInfoType } from '../../shared/enum/EnumRepository';
import CarouselFrame from './carousel/CarouselFrame';

export interface CarouselProps {
  peId: string;
  data: CarouselData;
  displaySize: DisplaySize;
  infoType?: PEInfoType;
}

const Carousel: React.FC<CarouselProps> = (props) => (
  <CarouselFrame {...props} isMobile={false} />
);

export default Carousel;
